import { render, staticRenderFns } from "./StudiesDirectorSpace.vue?vue&type=template&id=f7c4a528"
import script from "./StudiesDirectorSpace.vue?vue&type=script&lang=ts"
export * from "./StudiesDirectorSpace.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports